import _ from 'underscore';
import Vue from 'vue';

export default {

	state: () => ({
		byId: {},
		header: {
			buttons: [],
			page: {},
			tags: { fields: [], numTags: {} }
		},
		activeModule: null,
		navCounts: {},
	}),

	getters: {

		modules(state) {
			return _.sortBy(_.toArray(state.byId), 'order');
		},

		moduleHeader(state) {
			return state.header;
		},

		modulesByTableName(state) {
			return _.object(_.map(state.byId, function(item) {
				return [item.plural_table_name, item];
			}));
		},

		module(state) {
			return state.activeModule || {};
		},

		navCounts(state) {
			return state.navCounts || {};
		},

	},

	mutations: {

		// Header

		setHeaderButtons(state, buttons) {
			Vue.set(state.header, 'buttons', buttons);
		},

		setPageData(state, pageData) {
			Vue.set(state.header, 'page', pageData);
		},

		setHeaderTags(state, { fields, numTags }) {
			Vue.set(state.header, 'tags', { fields, numTags });
		},

		resetHeader(state, keepPage = false) {
			state.header = {
				buttons: [],
				page: keepPage ? state.header.page : {},
				tags: { fields: [], numTags: {} }
			};
		},

		// Modules

		setModules(state, modules) {
			state.byId = _.indexBy(modules, 'id');
		},

		setActiveModule(state, module) {
			state.activeModule = module;
		},

		// Nav

		setNavCount(state, { slug, count }) {
			state.navCounts = {
				...state.navCounts,
				[ slug ]: count,
			};
		},

		setNavCounts(state, navCounts) {
			state.navCounts = {
				...state.navCounts,
				...navCounts,
			};
		},

	},

	actions: {

		async loadModules({ commit }) {
			const { data } = await this.$api.get('/modules');

			commit('setModules', data.data);
		},

		async loadModuleCounts({ commit }) {
			try {
				const { data } = await this.$api.get('/modules/counts');

				commit('setNavCounts', data);
			} catch (e) {
				console.warn('Cannot load counts');
			}
		},

		async loadActiveModule({ commit }, slug) {
			const { data } = await this.$api.get('/module/' + slug);
			commit('setActiveModule', data);
		},

		setActiveModule({ commit }, module) {
			commit('setActiveModule', module);
			commit('setPageData', { title: module.name, icon: module.icon });
			commit('setTitle', module.name, { root: true });
		},

		resetHeader({ commit }, keepPage = false) {
			commit('resetHeader', keepPage);
		}
	},

};
